//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button as MaterialButton,
    IconButton,
    Select,
    MenuItem,
    Menu,
    InputLabel,
    FormControl,
    TextField,
    Chip,
    createTheme,
    ThemeProvider,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    CircularProgress,
    useTheme,
    Tooltip,
    Stack,
    Checkbox
} from '@mui/material';
import { createBooleanOperator, DatePickerControl, DateTimePickerControl, InputControl, NumericFormatInputControl, ReportRequestListModal } from '../../molecules';
import { useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal, useGetMerchantValueDatedPayments, IGetMerchantValueDatedPaymentsRequest, useGetAllMerchantList, useGetMerchantValueDatedPaymentDetails, usePostRequestReportToQueue, postTransactionReportRequestList } from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { StorageKeys } from '../../../common/storageKeys';
import { Table } from '../../../components';
import {
    GridColDef,
    GridPaginationModel,
    GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';
import { months, monthFilterOperator, MonthFilter } from '../../../components/atoms/grid-filter-operations';
import BaseFilterTableWithAccordion from '../../../components/atoms/BaseFilterTableWithAccordion';
import * as zod from 'zod';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Button } from "../../atoms";
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';

const currentYear = new Date().getFullYear();
const startYear = 2000;
const years = [];

for (let year = currentYear; year >= startYear; year--) {
    years.push({ name: year.toString(), value: year });
}

const MerchantValueDatedTransactionDetailsComponentRequestSchema = zod.object({
    merchantId: zod.any(),
    startDate: zod.custom<dayjs.Dayjs>(
        (val) => dayjs.isDayjs(val) && val !== null,
        "Başlangıç tarihi zorunludur"
    ),
    endDate: zod.custom<dayjs.Dayjs>(
        (val) => dayjs.isDayjs(val) && val !== null,
        "Bitiş tarihi zorunludur"
    ),
    orderId: zod.any()
}).refine(
    (data) => data.startDate.isValid(),
    {
        message: "Geçerli bir başlangıç tarihi giriniz",
        path: ["startDate"],
    }
)
    .refine(
        (data) => data.endDate.isValid(),
        {
            message: "Geçerli bir bitiş tarihi giriniz",
            path: ["endDate"],
        }
    );

type MerchantValueDatedTransactionDetailsComponentFormRequest = zod.infer<
    typeof MerchantValueDatedTransactionDetailsComponentRequestSchema
>;

const getMerchantValueDatedTransactionDetailsComponentFormRequestInitValues = (userType: number, currentMerchantId: string | null): MerchantValueDatedTransactionDetailsComponentFormRequest => {
    return {
        merchantId: userType === 2 && currentMerchantId ? [parseInt(currentMerchantId)] : null,
        orderId: null,
        startDate: dayjs().startOf('month'),
        endDate: dayjs().endOf('month'),
    };
};

export const MerchantValueDatedTransactionDetailsComponent = ({ merchant }: any) => {
    const theme = useTheme();
    const { showDelete, showUpdate, showCreate } = useAuthorization();
    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
    const [showTable, setShowTable] = useState(false)
    const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [isTableSubmitted, setIsTableSubmitted] = useState(false);

    // Get userType from localStorage to determine user permissions
    const userType = parseInt(localStorage.getItem(StorageKeys.userType) || "0");
    const currentMerchantId = localStorage.getItem(StorageKeys.merchantId);

    const { mutate: getMerchantValueDatedPayments, isLoading: isGetMerchantValueDatedPaymentsLoading } = useGetMerchantValueDatedPaymentDetails();
    const { mutate: postQueueReport, isLoading: isPostQueueReportLoading } = usePostRequestReportToQueue();
    const { data: rawMerchantList, isLoading: isGetAllMerchantListLoading } = useGetAllMerchantList("ACTIVE");

    var isPageLoading = isGetMerchantValueDatedPaymentsLoading ||
        isGetAllMerchantListLoading ||
        isPostQueueReportLoading;

    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantValueDatedTransactionDetailsComponentFormRequest>({
            resolver: zodResolver(MerchantValueDatedTransactionDetailsComponentRequestSchema),
            defaultValues: getMerchantValueDatedTransactionDetailsComponentFormRequestInitValues(userType, currentMerchantId),
        });

    const setSnackbar = useSetSnackBar();


    const merchantList = useMemo(() => {
        if (!rawMerchantList?.data) return [];

        // If userType is 2 (Merchant), show only current merchant
        if (userType === 2 && currentMerchantId) {
            const currentMerchant = rawMerchantList.data.find(
                (merchant: { merchantId: number }) => merchant.merchantId.toString() === currentMerchantId
            );
            if (currentMerchant) {
                return [{
                    label: `${currentMerchant.merchantName} (${currentMerchant.merchantId})`,
                    value: currentMerchant.merchantId,
                }];
            }
            return [];
        }

        // For other user types, show all merchants
        return rawMerchantList.data.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data, userType, currentMerchantId]);

    interface QueryOptions {
        field?: string;
        value?: any;
        clearFilter?: boolean;
        [key: string]: string | number | boolean | undefined | any;
    }

    const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });

    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const [dynamicFilters, setDynamicFilter] = useState<any>(() => {
        const baseFilters = [
            {
                field: 'startDate',
                values: [dayjs().startOf('month').format('YYYY-MM-DD')],
                valueType: RequestFilterValueTypeEnums.DATE,
                operationType: RequestFilterOperationTypeEnum.GREATER_THAN_OR_EQUAL
            },
            {
                field: 'endDate',
                values: [dayjs().endOf('month').format('YYYY-MM-DD')],
                valueType: RequestFilterValueTypeEnums.DATE,
                operationType: RequestFilterOperationTypeEnum.LESS_THAN_OR_EQUAL
            }
        ];

        // If userType is 2 (Merchant), add merchant filter automatically
        if (userType === 2 && currentMerchantId) {
            baseFilters.push({
                field: 'merchantId',
                values: [currentMerchantId],
                valueType: RequestFilterValueTypeEnums.NUMBER,
                operationType: RequestFilterOperationTypeEnum.CONTIANS
            });
        }

        return baseFilters;
    });

    useEffect(() => {
        let payload: IGetMerchantValueDatedPaymentsRequest = {
            filters: dynamicFilters,
            orderBy: "CreateDate",
            orderByDesc: true,
            page: paginationModel.page,
            size: paginationModel.pageSize,
        };

        getMerchantValueDatedPayments(payload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setTableData(data.data);
                    setFilterAccordionExpand(false);
                    setShowTable(true);
                } else {
                    setTableData({});
                    setSnackbar({
                        severity: "error",
                        description: "Bir hata oluştu.",
                        isOpen: true,
                    });
                }
            },
            onError: (error) => {
                setTableData({});
                setSnackbar({
                    severity: "error",
                    description: error.message || "Bir hata oluştu.",
                    isOpen: true,
                });
            }
        });
    }, [paginationModel, queryOptions, dynamicFilters, isTableSubmitted]);

    const debounce = (func: (...args: any[]) => void, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    interface FilterParams {
        [key: string]: string | number | boolean | null | undefined;
    }

    const getQueryParams = (filters: FilterParams) => {
        const queryParams: { [key: string]: string | number | boolean } = {};

        for (let key in filters) {
            let value = filters[key];
            // Eğer gelen değer string "false" ise onu boolean false'a çevir
            if (value === "false") {
                queryParams[key] = false;
            } else {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            return setQueryOptions({});
        }
        const queryParams = getQueryParams(filters);

        const isValueValid = (key: string, value: any): boolean => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'selectedMonth' || key === 'totalCount' || key === 'totalChargeAmount') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }

        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
        }


        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

    const booleanOptions = [
        { label: "Evet", value: true },
        { label: "Hayır", value: "false" },
    ];

    const getTxnTypeLabel = (txnType: string) => {
        const txnTypeMap: { [key: string]: string } = {
            'AUTH': 'Satış',
            'REFUND': 'İade',
            'CANCEL': 'İptal',
            'PRE_AUTH': 'Ön Provizyon',
            'POST_AUTH': 'Satış Kapama',
            'Auth': 'Satış',
            'Refund': 'İade',

        };
        return txnTypeMap[txnType] || txnType;
    };

    const columns: GridColDefExt[] = useMemo(() => {
        return [
            { field: 'merchantId', headerName: 'Üye No.', width: 120, columnType: RequestFilterValueTypeEnums.NUMBER },
            { field: 'merchantName', headerName: 'Üye İşyeri Adı', width: 350, columnType: RequestFilterValueTypeEnums.STRING },
            ...(userType !== 2 ? [{ 
                field: 'txnType', 
                headerName: 'İşlem Tipi', 
                width: 120, 
                columnType: RequestFilterValueTypeEnums.STRING,
                valueFormatter: (params: GridValueFormatterParams) => {
                    return getTxnTypeLabel(params.value);
                }
            }] : []),
            { field: 'orderId', headerName: 'Sipariş No', width: 200, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'bankCode', headerName: 'Banka Kodu', width: 120, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'bankName', headerName: 'Banka Adı', width: 200, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'maskedPan', headerName: 'Kart No', width: 150, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'cardHolderName', headerName: 'Kart Sahibi', width: 150, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: 'installmentCount',
                headerName: 'Taksit',
                width: 100,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'totalAmount',
                headerName: 'Toplam Tutar',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            },
            {
                field: 'merchantAmount',
                headerName: 'İşyeri Tutarı',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            },
            {
                field: 'merchantCommisionAmount',
                headerName: 'İşyeri Komisyon',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            },
            {
                field: 'merchantCommisionRate',
                headerName: 'İşyeri Komisyon Oranı (%)',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimalPercentage',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            },
            ...(userType !== 2 ? [{
                field: 'bankAmount',
                headerName: 'Banka Tutarı',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            }] : []),
            ...(userType !== 2 ? [{
                field: 'bankCommissionAmount',
                headerName: 'Banka Komisyon Tutarı',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            }] : []),
            ...(userType !== 2 ? [{
                field: 'bankCommissionRate',
                headerName: 'Banka Komisyon Oranı (%)',
                width: 130,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                type: 'decimalPercentage',
                valueFormatter: (params: GridValueFormatterParams) => {
                    return params.value?.toFixed(2);
                }
            }] : []),
            { field: 'authCode', headerName: 'Onay Kodu', width: 120, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: 'merchantblockedday',
                headerName: 'Bloke Gün',
                width: 100,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'transactionDate',
                headerName: 'İşlem Tarihi',
                width: 180,
                columnType: RequestFilterValueTypeEnums.DATE,
                valueFormatter: (params: GridValueFormatterParams) => {
                    return dayjs(params.value).format('DD.MM.YYYY HH:mm:ss');
                }
            },
            {
                field: 'paymentMerchantDate',
                headerName: 'İşyeri Ödeme Tarihi',
                width: 150,
                columnType: RequestFilterValueTypeEnums.DATE,
                valueFormatter: (params: GridValueFormatterParams) => {
                    return dayjs(params.value).format('DD.MM.YYYY');
                }
            },
            {
                field: 'paymentBankDate',
                headerName: 'Banka Ödeme Tarihi',
                width: 150,
                columnType: RequestFilterValueTypeEnums.DATE,
                valueFormatter: (params: GridValueFormatterParams) => {
                    return dayjs(params.value).format('DD.MM.YYYY');
                }
            }
        ];
    }, [menuAnchorEl, showUpdate, showDelete, userType]);

    const convertTableFiltersToRequestFilter = (tableFilters: any) => {

        let convertedFilters: any = [];

        tableFilters.items.map((item: any) => {

            var findColumn = columns.find(x => x.field == item.field);

            convertedFilters.push({
                field: item.field,
                values: [item.value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    function fieldValue(data: any[]): Record<string, string | number | boolean | undefined>[] {
        return data.map((item) => {
            return {
                'Üye No.': item?.merchantId,
                'Üye İşyeri Adı': item?.merchantName,
                'İşlem Tipi': getTxnTypeLabel(item?.txnType),
                'Sipariş No': item?.orderId,
                'Banka Kodu': item?.bankCode,
                'Banka Adı': item?.bankName,
                'Kart No': item?.maskedPan,
                'Kart Sahibi': item?.cardHolderName,
                'Taksit': item?.installmentCount,
                'Toplam Tutar': item?.totalAmount,
                'İşyeri Tutarı': item?.merchantAmount,
                'İşyeri Komisyon': item?.merchantCommisionAmount,
                'İşyeri Komisyon Oranı': item?.merchantCommisionRate ?? 0,
                'Banka Tutarı': item?.bankAmount,
                'Banka Komisyon Tutarı': item?.bankCommissionAmount,
                'Banka Komisyon Oranı': item?.bankCommissionRate ?? 0,
                'Onay Kodu': item?.authCode,
                'Bloke Gün': item?.merchantblockedday,
                'İşlem Tarihi': dayjs(item?.transactionDate).format('DD.MM.YYYY HH:mm:ss'),
                'İşyeri Ödeme Tarihi': dayjs(item?.paymentMerchantDate).format('DD.MM.YYYY'),
                'Banka Ödeme Tarihi': dayjs(item?.paymentBankDate).format('DD.MM.YYYY')
            };
        });
    }
    const onSave = () => {

        let payload = {
            filters: dynamicFilters,
            reportType: 2,
        };

        postQueueReport(
            payload,
            {
                onSuccess: (data) => {
                    if (data.isSuccess) {
                        setSnackbar({
                            severity: "info",
                            isOpen: true,
                            description: data.data,
                        });
                    } else {
                        if (data.message === "Kayit bulunamadi") {
                            setSnackbar({
                                severity: "info",
                                isOpen: true,
                                description: "Listede Kayıt Yoktur",
                            });
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data.message,
                                isOpen: true,
                            });
                        }
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    };


    const onSubmit = (data: MerchantValueDatedTransactionDetailsComponentFormRequest) => {
        setFilterAccordionExpand(false);
        setTableData(undefined);
        setShowTable(true);
        let newFilter = [...dynamicFilters];

        if (data.merchantId && data.merchantId.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'merchantId')) {
                newFilter.find((filter: any) => filter.field === 'merchantId').values = data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'merchantId',
                    values: data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'merchantId');
        }

        console.log('filter data', data);
        if (data.orderId) {
            if (newFilter.find((filter: any) => filter.field === 'orderId')) {
                newFilter.find((filter: any) => filter.field === 'orderId').values = [data.orderId];
            }
            else {
                newFilter.push({
                    field: 'orderId',
                    values: [data.orderId],
                    valueType: RequestFilterValueTypeEnums.STRING,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'orderId');
        }

        if (data.startDate) {
            if (newFilter.find((filter: any) => filter.field === 'startDate')) {
                newFilter.find((filter: any) => filter.field === 'startDate').values = [data.startDate.format('YYYY-MM-DD')];
            } else {
                newFilter.push({
                    field: 'startDate',
                    values: [data.startDate.format('YYYY-MM-DD'), data.endDate.format('YYYY-MM-DD')],
                    valueType: RequestFilterValueTypeEnums.DATE,
                    operationType: RequestFilterOperationTypeEnum.GREATER_THAN_OR_EQUAL
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'startDate');
        }

        if (data.endDate) {
            if (newFilter.find((filter: any) => filter.field === 'endDate')) {
                newFilter.find((filter: any) => filter.field === 'endDate').values = [data.endDate.format('YYYY-MM-DD')];
            } else {
                newFilter.push({
                    field: 'endDate',
                    values: [data.endDate.format('YYYY-MM-DD')],
                    valueType: RequestFilterValueTypeEnums.DATE,
                    operationType: RequestFilterOperationTypeEnum.LESS_THAN_OR_EQUAL
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'endDate');
        }

        setDynamicFilter(newFilter);
    }

    const [isReportListActive, setIsReportListActive] = useState(false);
    const [reportFiles, setReportFiles] = useState([]);
    const getReportList = () => {
        postTransactionReportRequestList({
            reportType: 2,
        })
            .then((data) => {
                setReportFiles(data.data.result);
                setIsReportListActive(true);
            })
    };

    return (

        <ThemeProvider theme={theme}>
            {isPageLoading && <Loading />}
            <Box className="p-4" sx={{ p: 2 }}>

                <BaseFilterTableWithAccordion
                    isExpanded={isFilterAccordionExpanded}
                    setExpanded={setFilterAccordionExpand}
                    setTableVisibility={setShowTable}
                    child={<Stack spacing={4}>
                        <Stack
                            spacing={3}
                            direction={isDesktop ? "row" : "column"}
                            width={'100%'}
                        >
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        control={control}
                                        name="merchantId"
                                        render={({ field }) => (
                                            <Autocomplete
                                                multiple
                                                id="merchant-multi-checkbox"
                                                options={merchantList}
                                                disableCloseOnSelect
                                                disabled={userType === 2}
                                                value={merchantList.filter(option => field.value?.includes(option.value)) || []}
                                                getOptionLabel={(option) => option.label}
                                                onChange={(event, newValue) => {
                                                    // Seçilen tüm değerlerin dizisini güncelliyoruz
                                                    field.onChange(newValue.map((item) => item.value));
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props} key={option.value}>
                                                        <Checkbox
                                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                <DatePickerControl
                                    control={control}
                                    id="startDate"

                                    label="İşyeri Ödeme Başlangıç Tarihi"
                                    views={['year', 'month', 'day']}
                                />
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                <DatePickerControl
                                    control={control}
                                    id="endDate"

                                    label="İşyeri Ödeme Bitiş Tarihi"
                                    views={['year', 'month', 'day']}
                                />
                            </FormControl>
                            <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                <InputControl
                                    label="Sipariş Numarası"
                                    control={control}
                                    id="orderId"
                                />
                            </FormControl>
                            <Button
                                onClick={handleSubmit(onSubmit)}
                                variant="contained"
                                text={"ARA"}
                            />
                        </Stack>
                    </Stack>}
                    summary={'Filtre yönetimi'}
                ></BaseFilterTableWithAccordion>

                <Box sx={{ mt: 2 }}>
                    {(tableData && showTable) && <Table
                        filterKey="merchantPOSUsageFeeFilterKey"
                        columnVisibilityConfigKey="merchantPOSUsageFeeFilterColumnVisibilityKey"
                        hasActiveFilters={hasActiveFilters}
                        handleFilterChange={handleFilterChange}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handleChangePagination}
                        paginationMode="server"
                        rowCount={tableData?.totalItems || 0}
                        isRowSelectable={() => false}
                        customLabelDisplayedRows={true}
                        autoHeight={false}
                        getRowId={() => { return Math.floor(Math.random() * 100000) }}
                        rows={tableData?.result || []}
                        columns={columns}
                        getRowClassName={(params: { row: { status: string } }) => {
                            if (params.row.status === "PASSIVE") return "blocked-row";
                            if (params.row.status === "BLOCKED") return "pasive-row";
                            return "";
                        }}
                        extraToolbarButton={<>
                            <MaterialButton sx={{ marginLeft: 2 }} onClick={() => onSave()}>
                                <AddchartIcon color="primary" />
                                RAPOR OLUŞTUR
                            </MaterialButton>
                            <MaterialButton sx={{ marginLeft: 2 }} onClick={() => { getReportList(); }}>
                                <BarChartIcon color="primary" />
                                RAPORLAR
                            </MaterialButton>
                        </>}
                        exportFileName="Üye İşyeri POS Kullanım Bedeli Raporu"
                        onSave={null}
                    />}
                    <ReportRequestListModal
                        isOpen={isReportListActive}
                        onClose={() => { setIsReportListActive(false); }}
                        title="Raporlar"
                        reportFiles={reportFiles}
                        closeButtonText="Kapat"
                        reportType={2}
                    ></ReportRequestListModal>
                </Box>
            </Box>
        </ThemeProvider>
    );
};